// extracted by mini-css-extract-plugin
export default {"addToCartControl":"iY-z","giftCard":"jY-z","btnContainer":"kY-z","cartButton":"lY-z","disabled":"mY-z"};